import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Game } from '../../../Core'
import * as StoryLineSelectors from '../../../Core/StoryLine/storyLine.selectors'

class ErrorPopup extends React.Component {
  constructor(props) {
    super(props)
  }

  closePopup() {
    const { removePopup, gamePopups } = this.props
    setTimeout(() => {
      removePopup(gamePopups[0])
    }, 200)
  }

  render() {
    const { gamePopups, dataPopups } = this.props
    const text = dataPopups[gamePopups[0]].content
    return (
      <div className="popup--game">
        <div className="popup--box">
          <div className="popup--box__canvas">
            <div className="popup--text blue">
              <FormattedMessage id={text} />
            </div>
            <div className="popup--buttons">
              <div
                onClick={() => {
                  this.closePopup()
                }}
                className="btn--shape shape--blue"
              >
                <div className="btn--shape__canvas">
                  <FormattedMessage id="phase.accept" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
  }
}

const mapStateToProps = (state) => {
  return {
    gamePopups: Game.selectors.getPopups(state),
    dataPopups: StoryLineSelectors.getPopups(state),
  }
}

ErrorPopup.propTypes = {
  removePopup: PropTypes.func,
  gamePopups: PropTypes.array,
  dataPopups: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ErrorPopup))
